module.exports = "https://www.gc-qa.gnp.com.mx/cc9aa4a7106877af46ff96b707f12052.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf_icon.svg
// module id = 986
// module chunks = 0